import { VerticalContainer, useForm } from '@american-autonomy/ag-ui';

import Form from 'components/Form';
import FormSubmitPanel from 'components/FormSubmitPanel';
import ClientFormFields from 'components/forms/ClientFormFields';

import useClient from 'hooks/useClient';
import useFormDiscardConfirmation from 'hooks/useFormDiscardConfirmation';

import useTranslation from './hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props, UpdateClientFormSchema } from './types';

import styles from './styles.module.scss';

const UpdateClientForm: FunctionComponent<Props> = ({
    className = '',
    formValues,
    isClosing,
    onClose,
    setIsClosing,
    testId = TEST_ID
}) => {
    const { updateClient } = useClient();
    const { SAVE } = useTranslation();

    const form = useForm<UpdateClientFormSchema>({
        defaultValues: formValues,
        mode: 'onChange'
    });

    const {
        formState: { errors, isDirty },
        handleSubmit
    } = form;

    const { confirmationPanel, showConfirmation } = useFormDiscardConfirmation({
        isDirty,
        onCancelClose: () => setIsClosing?.(false),
        onClose,
        requestingClose: isClosing
    });

    const onSubmit = async (data: UpdateClientFormSchema) => {
        if (!formValues) {
            return;
        }

        const client = await updateClient({ client: data, id: formValues.id });

        if (client) {
            onClose?.();
        }
    };

    return (
        <VerticalContainer className={`${styles.updateClientForm} ${className}`} testId={testId}>
            {showConfirmation ? (
                confirmationPanel
            ) : (
                <Form className={styles.form} form={form}>
                    <ClientFormFields />

                    <FormSubmitPanel
                        buttonText={SAVE}
                        className={styles.formSubmitPanel}
                        errors={errors}
                        onSubmit={handleSubmit(onSubmit)}
                    />
                </Form>
            )}
        </VerticalContainer>
    );
};

export default UpdateClientForm;
